// extracted by mini-css-extract-plugin
module.exports = {"templatesContainer":"LandingWizardQuiz_templatesContainer__x821x","card":"LandingWizardQuiz_card__2WoxQ","leftContainer":"LandingWizardQuiz_leftContainer__2WHsl"};